export default {
	windowEl: window,
	documentEl: document,
	htmlEl: document.documentElement,
	bodyEl: document.body,
};
